import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersWithdrawalsByUser = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/withdrawals/by-user`, {params});
};